import {Modal, Button} from "semantic-ui-react";
import React from "react";
import {CustomModalHeader} from "../../components/custom-common";

export const ConfirmChangeMethodModal = ({onClose, displayModal, submit}) => {

  return (
    <Modal
      onClose={onClose}
      open={displayModal}
      style={{width: '624px', maxWidth: '95%'}}
    >
      <CustomModalHeader title={"Are you sure you want to change two-factor authentication method?"}
                         onClose={onClose}
                         className={"customModalHeader"} />
      <Modal.Content style={{overflowY: 'auto'}} className={"small"}>
        <p style={{fontSize: '16px'}}>
          Re-configuring your authentication will invalidate your previous authentication method.
        </p>

        <div style={{marginTop: '30px', display: 'flex', justifyContent: 'flex-end'}}>
          <Button basic primary onClick={onClose}>
            Cancel
          </Button>
          <Button primary
                  onClick={submit}>
            Continue
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  )
}
